window.addEventListener("DOMContentLoaded", () => {
    const accordionParents = Array.from(document.querySelectorAll(".faq-section-acordions"));
    
    const accordionClass = customElements.get("accordion-component");
    if (accordionClass) {
        const accordionInstance = new accordionClass();
        
        accordionParents.forEach((parent) => {
          const accordionTitle = Array.from(parent.getElementsByClassName("faq-section-acordion-heading"));
          const accordionContent = Array.from(parent.getElementsByClassName("faq-section-acordion-content"));
          accordionInstance.renderAccordion(parent, accordionTitle, accordionContent, false);
          setTimeout(() => {
            parent.classList.add('faq-section-acordions--visible');
          }, 100);
        });
    }    
});